// App Creator AI Tool Set - Base class for app creator-specific AI tool sets
// Extends AIToolSet - provides access to app creator tools via built-in cross-references
//
// Architecture:
// - All three systems (ToolSystem, AIToolSystem, AIInferenceSystem) have cross-references
// - AppCreatorAIToolSet inherits this.aiToolSystem which directly references AppCreatorAIToolSystem
// - No getter needed since this.aiToolSystem.toolSystem gives direct access to app creator tools

import { AIToolSet } from "../../../base/AIToolSet.js";

export class AppCreatorAIToolSet extends AIToolSet {
  // Inherits cross-references from base AIToolSet:
  // - this.toolSystem → AppCreatorToolSystem instance
  // - this.aiInferenceSystem → AppCreatorAIInferenceSystem instance
}